import { useQuery, skipToken } from '@tanstack/react-query';
import type { UserDevice } from '@citibox-panel/api-client';

export interface UseUserDevice {
  device: UserDevice | null | undefined;
  isPending: boolean;
  isError: boolean;
  refetch: () => void;
}

// Device telemetry, keyed by the numeric USER ID. The query is skipped (skipToken)
// until the account resolves the id, which also narrows it to a string inside the
// query function. The error is left as inline state (default throwOnError: false):
// a device failure must surface a retry on the device card alone, never tear down
// the account card via the shell boundary.
export function useUserDevice(
  id: string | undefined,
  fetchDevice: (id: string) => Promise<UserDevice | null>,
): UseUserDevice {
  const { data, isPending, isError, refetch } = useQuery({
    queryKey: ['user-device', id],
    queryFn: id === undefined ? skipToken : () => fetchDevice(id),
  });

  return {
    device: data,
    isPending,
    isError,
    refetch: () => void refetch(),
  };
}
